import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NA_LABEL } from '../common/AppConstants';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const isNA = (v) => v === null || v === undefined || v === NA_LABEL;

export default function StatsCard({
  icon, title, value, loading = false, trend, color='#3b82f6', redirectTo=undefined
}) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={redirectTo ? () => navigate(redirectTo) : undefined}
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '12px',
        backgroundColor: 'white',
        padding: '24px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
        boxShadow: isHovered
          ? '0 12px 24px rgba(0,0,0,0.12)'
          : '0 2px 8px rgba(0,0,0,0.08)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${color}, ${color}dd)`,
          opacity: isHovered ? 1 : 0.7,
          transition: 'opacity 0.3s ease',
        }}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: 500,
              letterSpacing: '0.5px',
              fontSize: '0.75rem',
              marginBottom: '12px',
              color: '#64748b',
            }}
          >
            {title}
          </div>
          {loading ? (
            <>
              <div
                style={{
                  width: '120px',
                  height: '48px',
                  backgroundColor: '#e2e8f0',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
              <div
                style={{
                  width: '60px',
                  height: '20px',
                  backgroundColor: '#e2e8f0',
                  borderRadius: '4px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
            </>
          ) : isNA(value) ? (
            <div/>
          ) : (
            <>
              <div
                style={{
                  fontSize: '2rem',
                  fontWeight: 700,
                  marginBottom: '4px',
                  background: `linear-gradient(135deg, ${color}, ${color}cc)`,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  letterSpacing: '-0.5px',
                }}
              >
                {value}
              </div>
              {trend !== undefined && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <TrendingUpIcon size={14} color={trend > 0 ? '#10b981' : '#ef4444'} />
                  <span
                    style={{
                      fontSize: '0.75rem',
                      color: trend > 0 ? '#10b981' : '#ef4444',
                      fontWeight: 600,
                    }}
                  >
                    {trend > 0 ? '+' : ''}{trend}%
                  </span>
                  <span
                    style={{
                      fontSize: '0.75rem',
                      color: '#94a3b8',
                      marginLeft: '4px',
                    }}
                  >
                    vs last period
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        <div
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: `${color}15`,
            color: color,
            transition: 'all 0.3s ease',
            transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
          }}
        >
          {icon}
        </div>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}
